import { FC } from 'react';
import ChartCard from './ChartCard';
import { useThemeColors } from './useThemeColors';

interface FunnelStep {
  label: string;
  value: number;
}

interface FunnelCardProps {
  title: string;
  subtitle?: string;
  steps: FunnelStep[];
  height?: number;
}

/**
 * Funil de conversão em barras horizontais. Cada degrau mostra:
 * - label, valor absoluto
 * - barra proporcional ao máximo
 * - % de conversão em relação ao degrau anterior
 */
const FunnelCard: FC<FunnelCardProps> = ({ title, subtitle, steps, height = 280 }) => {
  const colors = useThemeColors();
  const max = Math.max(...steps.map((s) => s.value), 1);

  return (
    <ChartCard title={title} subtitle={subtitle} height={height}>
      <div className="w-full h-full flex flex-col justify-around gap-2">
        {steps.map((step, idx) => {
          const pct = (step.value / max) * 100;
          const prev = idx > 0 ? steps[idx - 1].value : null;
          const conversion =
            prev && prev > 0 ? Math.round((step.value / prev) * 100) : null;
          return (
            <div key={step.label} className="flex flex-col gap-1">
              <div className="flex justify-between text-xs text-content-muted">
                <span>{step.label}</span>
                <span>
                  {step.value.toLocaleString('pt-BR')}
                  {conversion !== null && (
                    <span className="ml-2 opacity-70">({conversion}%)</span>
                  )}
                </span>
              </div>
              <div
                className="h-7 rounded-md"
                style={{
                  background: `linear-gradient(90deg, ${colors.palette[idx % colors.palette.length]} 0%, ${colors.palette[idx % colors.palette.length]} ${pct}%, ${colors.grid} ${pct}%, ${colors.grid} 100%)`,
                  border: `1px solid ${colors.border}`,
                }}
              />
            </div>
          );
        })}
      </div>
    </ChartCard>
  );
};

export default FunnelCard;
